import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

/**
 * Sample usage:
 *
 *     <expandable expandableTitle="Title">
 *         Lorem ipsum dolor
 *     </expandable>
 */
@Component({
    selector: 'expandable',
    templateUrl: './expandable.html',
    styleUrls: ['./expandable.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpandableComponent {
    /**
     * Title
     */
    @Input()
    expandableTitle?: string;

    @Input()
    expandableLayout: 'default' | 'filled' = 'default';

    @Input()
    whiteMode = false;

    @Input()
    toggleState = false;

    @Input()
    @HostBinding('class._fadeOut')
    fadeOut = false;

    /**
     * Dependencies
     */
    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    protected toggle() {
        this.toggleState = !this.toggleState;
        this.changeDetectorRef.detectChanges();
    }
}
